import React from 'react';
import { AlertTriangle, ArrowLeft, Phone } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';

export const NoDeliveryDaysNotice = ({ navigate }) => (
  <div className="flex items-center justify-center min-h-[400px]" data-testid="no-delivery-days-notice">
    <Card className="max-w-md w-full">
      <CardContent className="pt-8 pb-8 text-center space-y-4">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto">
          <AlertTriangle className="h-8 w-8 text-amber-600" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900">Delivery Schedule Not Set Up</h2>
        <p className="text-gray-600 text-sm">
          Your account doesn't have delivery days configured yet. Please contact your account administrator to set up your delivery schedule before placing orders.
        </p>
        <div className="flex flex-col gap-2 pt-2">
          <Button onClick={() => navigate('/client/shop')} variant="outline" data-testid="back-to-shop-btn">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Shop
          </Button>
          <Button onClick={() => navigate('/client/help')} className="bg-amber-500 hover:bg-amber-600" data-testid="contact-admin-btn">
            <Phone className="h-4 w-4 mr-2" />
            Contact Admin
          </Button>
        </div>
      </CardContent>
    </Card>
  </div>
);
